export const DATE_FORMAT = 'DD MMMM YYYY'




// WEBPACK FOOTER //
// ./js/website/constants.js